import { Component, ElementRef, ViewChild, OnInit, NgZone } from '@angular/core';
import { T4DatatableWidget, CreateServiceRequestDialog } from '../../../../t4common/';
import { PageBase, CustomerType } from 't4core';




@Component({
    selector: 'customers',
    styleUrls: ['./customers.component.css'],
    templateUrl: './customers.component.html',
})
export class CustomersComponent extends PageBase implements OnInit {

    @ViewChild("datatable", {static: false}) table: T4DatatableWidget;
  public customerType = CustomerType;

  @ViewChild("canvas", { static: true })
  public canvas: ElementRef<HTMLCanvasElement>;
  private ctx: CanvasRenderingContext2D;
  private requestId;
  private interval;

  constructor(el: ElementRef, private ngZone: NgZone) {
    super(el, "CustomerList");
  }

  public update() {
    this.table.update();

  }

  ngOnInit(): void {
    this.ctx = this.canvas.nativeElement.getContext('2d');
    this.ngZone.runOutsideAngular(() => this.tick());
    setInterval(() => {
      this.tick();
    }, 20);

    this.play();
  }

  private car: Car;
  private trailer: Trailer;

  tick() {
    if (this.car) {
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
      this.car.move();
      this.trailer.move();
      this.requestId = requestAnimationFrame(() => this.tick);
    }
  }

  play() {
    this.car = new Car(this.ctx);
    this.trailer = new Trailer(this.ctx, this.car);
    this.requestId = requestAnimationFrame(() => this.tick);
    this.tick();
  }

  ngOnDestroy() {
    clearInterval(this.interval);
    cancelAnimationFrame(this.requestId);
  }


}

export class Car {
  private color = 'red';
  public x = 300;
  public y = 300;
  public width = 40;
  public height = 30;

  public direction: number = 0;//Math.random() * 2 * Math.PI;
  public velocity: number = 3;

  private dDirection: number = 0;
  private dDirectionSign: number = 1;

  constructor(private ctx: CanvasRenderingContext2D) { }

  move() {
    var dx = this.velocity * Math.cos(this.direction);
    var dy = this.velocity * Math.sin(this.direction);
    this.x += dx;
    this.y += dy;

    if (this.x > 600 + this.width) this.x = -this.width;
    if (this.x < -this.width) this.x = 600 + this.width;
    if (this.y > 600 + this.height) this.y = -this.height;
    if (this.y < -this.height) this.y = 600 + this.height;
    

    this.direction += this.dDirection;
    

    if (Math.random() < 0.05) this.dDirectionSign *= -1;
    if (Math.random() < 0.5)
      if(Math.abs(this.dDirection + ((Math.PI / 180) * this.dDirectionSign)) < (Math.PI / 80))
        this.dDirection += ((Math.PI / 180) * this.dDirectionSign);

    this.draw();
  }

  private draw() {
    // first save the untranslated/unrotated context
    this.ctx.save();

    this.ctx.beginPath();
    // move the rotation point to the center of the rect
    this.ctx.translate((this.x + this.width / 2), (this.y + this.height / 2))
    // rotate the rect
    this.ctx.rotate(this.direction);

    this.ctx.fillStyle = this.color;
    this.ctx.fillRect(-this.width / 2, -this.height / 2, this.width, this.height);

    // restore the context to its untranslated/unrotated state
    this.ctx.restore();

  }
}

export class Trailer {
  private color = 'blue';
  private x = 300;
  private y = 300;
  private width = 40;
  private height = 30;

  private direction: number = 0;//Math.random() * 2 * Math.PI;

  private anglePercentage: number = 0;



  constructor(private ctx: CanvasRenderingContext2D, private car: Car) {
    this.x = car.x - this.width * Math.cos(car.direction);
    this.y = car.y - this.height * Math.sin(car.direction);
    this.direction = this.car.direction;
  }

  move() {
    var dAlpha = this.car.direction - this.direction;
    var dxCar = this.car.velocity * Math.cos(dAlpha);
    var dyCar = this.car.velocity * Math.sin(dAlpha);

    // Turn
    var alpha = Math.atan(dyCar / this.width);
    this.anglePercentage = dAlpha / (Math.PI / 2);

    this.direction += alpha;

    // Move
    var xTow = this.car.x;
    var yTow = this.car.y + (15 * Math.sin(this.car.direction + Math.PI / 2));

    var xHitch = this.x + (this.width * 1.5);
    var yHitch = this.y + (15);

    var dx = (xTow - xHitch);
    var dy = (yTow - yHitch);

    this.x += dx;
    this.y += dy;

    //this.ctx.save();
    //this.ctx.beginPath();
    //this.ctx.fillStyle = "red";
    //this.ctx.translate((this.car.x + this.car.width / 2), (this.car.y + this.car.height / 2))
    //this.ctx.rotate(this.direction);
    //this.ctx.ellipse(xTow - 1 - (this.car.x + this.car.width / 2), yTow - 1 - (this.car.y + this.car.height / 2), 2, 2, 0, 0, Math.PI * 2);
    //this.ctx.fill();
    //this.ctx.closePath();
    //this.ctx.restore();
    //this.ctx.save();
    //this.ctx.translate((this.x + this.width / 2), (this.y + this.height / 2))
    //this.ctx.rotate(this.direction);
    //this.ctx.fillStyle = "green";
    //this.ctx.ellipse(xHitch - 1 - (this.x + this.width / 2), yHitch - 1 - (this.y + this.height / 2), 2, 2, 0, 0, Math.PI * 2);
    //this.ctx.fill();
    //this.ctx.closePath();
    //this.ctx.restore();

    

    if (this.x > 600 + this.width) this.x = -this.width;
    if (this.x < -this.width) this.x = 600 + this.width;
    if (this.y > 600 + this.height) this.y = -this.height;
    if (this.y < -this.height) this.y = 600 + this.height;

    this.draw();
  }

  private draw() {
    // first save the untranslated/unrotated context
    this.ctx.save();

    this.ctx.beginPath();
    // move the rotation point to the center of the rect
    this.ctx.translate((this.x + this.width / 2), this.y + (this.height * (1 + this.anglePercentage) / 2));
    // rotate the rect
    this.ctx.rotate(this.direction);

    this.ctx.fillStyle = this.color;
    this.ctx.fillRect(-this.width / 2, -(this.height * (1 + this.anglePercentage) / 2), this.width, this.height);

    this.ctx.fillStyle = "black";
    this.ctx.fillRect(0, 0, this.width, 1);

    // restore the context to its untranslated/unrotated state
    this.ctx.restore();

  }
}
